import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {map, catchError } from 'rxjs/operators';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TicketService {
  tickets: any;
  constructor(private http: HttpClient) { }

  getTickets(status = null, page, sorting, filtering, per_page = 8): Observable<any> {
    let add_url = '';
    if (filtering.subject_matter !== '') {
      add_url = '&subject_matter=' + filtering.subject_matter;
    }
    if (filtering.client !== '') {
      add_url = add_url + '&client=' + filtering.client;
    }
    if (filtering.requester !== '') {
      add_url = add_url + '&requester=' + filtering.requester;
    }
    if (filtering.assigned_to !== '') {
      add_url = add_url + '&assigned_to=' + filtering.assigned_to;
    }
    if (filtering.subject !== '') {
      add_url = add_url + '&subject=' + filtering.subject;
    }
    if (filtering.search !== '') {
      add_url = add_url + '&search=' + filtering.search;
    }
    if (filtering.ticket_number !== '' && typeof filtering.ticket_number !== 'undefined') {
      add_url = add_url + '&ticket_number=' + filtering.ticket_number;
    }
    // "Unknown ..." filters: sent only when on, so callers without these keys are unaffected.
    for (const flag of ['client_missing', 'requester_missing', 'assigned_missing']) {
      if (Number(filtering[flag]) === 1) {
        add_url = add_url + '&' + flag + '=1';
      }
    }

    if (status == null) {
      return this.http.get( environment.apiUrl + 'ticket/?page=' + page
                  + '&per_page=' + per_page + '&sort_by=' + sorting.value + '&sort_type='
                  + sorting.sort + '' + add_url)
        .pipe(map((res: any) => {
          return res;
        }));
    } else {
        return this.http.get(environment.apiUrl + 'ticket/?page=' + page + '&per_page=' + per_page + '&status='
                    + status + '&sort_by=' + sorting.value + '&sort_type=' + sorting.sort
                    + '' + add_url)
        .pipe(map((res: any) => {
          return res;
        }));
    }
  }


  getSingleTickets( id ) {
    return this.http.get( environment.apiUrl + 'ticket/' + id)
    .pipe(
      map( res => {
        return res;
      })
    );
  }


  saveTickets(tikets, token) {
     this.http.post(environment.apiUrl + 'ticket/', this.tickets
     ).subscribe(data => {
     });
  }

  updateTickets(tickets, token, id) {
    return this.http.post(environment.apiUrl + 'ticket/' + id, tickets);
  }

  deleteTicket(token, id) {
    return this.http.delete(environment.apiUrl + 'ticket/' + id);
  }

  downloadFile(fileId: number): Observable<HttpResponse<Blob>> {
    return this.http.get(environment.apiUrl + 'ticket/file/' + fileId, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  getTicketAccess(id): Observable<any> {
    return this.http.get(environment.apiUrl + 'ticket/' + id + '/access');
  }

  addTicketAccess(id, user_id, scope): Observable<any> {
    const data = new FormData();
    data.append('user_id', user_id);
    data.append('scope', scope);
    return this.http.post(environment.apiUrl + 'ticket/' + id + '/access', data);
  }

  removeTicketAccess(id, user_id): Observable<any> {
    return this.http.delete(environment.apiUrl + 'ticket/' + id + '/access/' + user_id);
  }

}
